/*
import React from "react";

const TrainingSchool = ({ id_training_school }) => {
  return (
    <div className="training-school-page">
      <h1>Training School</h1>
      <p>
        Stai visualizzando la pagina per: <strong>{id_training_school}</strong>
      </p>
      <p>
        Stai visualizzando la pagina per: <strong>{id_training_school.split("/")[0]}</strong>
      </p>
      <p>
        Stai visualizzando la pagina per: <strong>{id_training_school.split("/")[1]}</strong>
      </p>
    </div>
  );
};

export default TrainingSchool;
*/

import React, { useEffect, useState } from "react";
import axios from "axios";
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import serverConfig from "../config";
import "./Home.css";
//import SidebarLeft from "../SidebarLeft";
//import SidebarRight from "../SidebarRight";
//import { useParams } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
//import updateImagePaths from "../utils/UpdateImagePaths";
import UpdatePaths from "../utils/UpdatePaths";

import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import TrainingSchoolRegistration from "./TrainingSchoolRegistration";

const TrainingSchool = ({ id_training_school }) => {
  //const { year, name_training_school } = useParams();

  const [year_training_school, setYearNameTrainingSchool] = useState(null);
  const [name_training_school, setNameTrainingSchool] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    //const parts = id_training_school.split("/");
    const parts = id_training_school.split("-");
    const extractedYear = parts[0];
    const extractedName = parts[1];

    if (!extractedYear || !extractedName) {
      navigate("/training_schools");
    } else {
      setYearNameTrainingSchool(extractedYear);
      setNameTrainingSchool(extractedName);
    }
  }, [id_training_school]);

  const [content, setContent] = useState(null);
  const [dateRegistration, setDateRegistration] = useState(null);
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  useEffect(() => {
    if (year_training_school && name_training_school) {
      axios
        .post(`${serverConfig.serverUrl}/get_training_school`, {
          year: year_training_school,
          name_training_school: name_training_school,
        })
        .then((response) => {
          //const data = response.data;
          const data = response.data["data_training"];
          const exist = response.data["exist"];

          if (exist) {
            const updatedContent = {
              home: UpdatePaths(
                data.home,
                "img/training_schools/",
                "file/training_schools/"
              ),
              info: UpdatePaths(
                data.info,
                "img/training_schools/",
                "file/training_schools/"
              ),
              intro: UpdatePaths(
                data.intro,
                "img/training_schools/",
                "file/training_schools/"
              ),
              participation: UpdatePaths(
                data.participation,
                "img/training_schools/",
                "file/training_schools/"
              ),
              professors: UpdatePaths(
                data.professors,
                "img/training_schools/",
                "file/training_schools/"
              ),
              program: UpdatePaths(
                data.program,
                "img/training_schools/",
                "file/training_schools/"
              ),
            };
            setContent(updatedContent);
            setDateRegistration(data["dateRegistration"]);
          } else {
            toast.error("Non esiste la scuola di formazione indicata");
            navigate("/training_schools");
          }
        })
        .catch((error) => {
          toast.error("La risorsa non è al momento disponibile");
        });
    }
  }, [name_training_school, year_training_school]);

  const [activeTab, setActiveTab] = useState("home");
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const navContents = (
    <>
      <Nav>
        <NavItem>
          {content && content.home && (
            <NavLink
              style={
                activeTab === "home"
                  ? {
                      color: "#F5F7FA",
                      backgroundColor: "#003366",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "15px",
                    }
                  : {
                      color: "#2C2C2C",
                      backgroundColor: "#D8DEE9",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "12px",
                    }
              }
              onClick={() => {
                toggle("home");
              }}
            >
              HOME
            </NavLink>
          )}
        </NavItem>
        <NavItem>
          {content && content.intro && (
            <NavLink
              style={
                activeTab === "intro"
                  ? {
                      color: "#F5F7FA",
                      backgroundColor: "#003366",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "15px",
                    }
                  : {
                      color: "#2C2C2C",
                      backgroundColor: "#D8DEE9",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "12px",
                    }
              }
              onClick={() => {
                toggle("intro");
              }}
            >
              INTRODUZIONE
            </NavLink>
          )}
        </NavItem>
        <NavItem>
          {content && content.professors && (
            <NavLink
              style={
                activeTab === "professors"
                  ? {
                      color: "#F5F7FA",
                      backgroundColor: "#003366",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "15px",
                    }
                  : {
                      color: "#2C2C2C",
                      backgroundColor: "#D8DEE9",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "12px",
                    }
              }
              onClick={() => {
                toggle("professors");
              }}
            >
              DOCENTI
            </NavLink>
          )}
        </NavItem>
        <NavItem>
          {content && content.program && (
            <NavLink
              style={
                activeTab === "program"
                  ? {
                      color: "#F5F7FA",
                      backgroundColor: "#003366",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "15px",
                    }
                  : {
                      color: "#2C2C2C",
                      backgroundColor: "#D8DEE9",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "12px",
                    }
              }
              onClick={() => {
                toggle("program");
              }}
            >
              PROGRAMMA
            </NavLink>
          )}
        </NavItem>
        <NavItem>
          {content && content.participation && (
            <NavLink
              style={
                activeTab === "participation"
                  ? {
                      color: "#F5F7FA",
                      backgroundColor: "#003366",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "15px",
                    }
                  : {
                      color: "#2C2C2C",
                      backgroundColor: "#D8DEE9",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "12px",
                    }
              }
              onClick={() => {
                toggle("participation");
              }}
            >
              PARTECIPAZIONE
            </NavLink>
          )}
        </NavItem>
        <NavItem>
          {content && content.info && (
            <NavLink
              style={
                activeTab === "info"
                  ? {
                      color: "#F5F7FA",
                      backgroundColor: "#003366",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "15px",
                    }
                  : {
                      color: "#2C2C2C",
                      backgroundColor: "#D8DEE9",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "12px",
                    }
              }
              onClick={() => {
                toggle("info");
              }}
            >
              INFORMAZIONI
            </NavLink>
          )}
        </NavItem>
      </Nav>
    </>
  );

  const visualizationMode = (content) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        <div
          style={{
            boxShadow: "0 0 10px 2px #003366",
            margin: "20px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          {content}
        </div>
      </div>
    </div>
  );

  const contentTrainingSchool = (
    <div
      style={{ backgroundColor: "#FAFAFA", color: "#2C2C2C", height: "100vh" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {navContents}
      </div>
      {content && (
        <TabContent activeTab={activeTab}>
          <TabPane tabId="home">
            {content.home &&
              visualizationMode(
                <div
                  style={{
                    padding: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: content.home,
                  }}
                />
              )}
          </TabPane>
          <TabPane tabId="intro">
            {content.intro &&
              visualizationMode(
                <div
                  style={{
                    padding: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: content.intro,
                  }}
                />
              )}
          </TabPane>
          <TabPane tabId="professors">
            {content.professors &&
              visualizationMode(
                <div
                  style={{
                    padding: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: content.professors,
                  }}
                />
              )}
          </TabPane>
          <TabPane tabId="program">
            {content.program &&
              visualizationMode(
                <div
                  style={{
                    padding: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: content.program,
                  }}
                />
              )}
          </TabPane>
          <TabPane tabId="participation">
            {content.participation &&
              visualizationMode(
                <>
                  <div
                    style={{
                      padding: "10px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: content.participation,
                    }}
                  />
                </>
              )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "70%" }}>
                {/*}
                <div
                  style={{
                    boxShadow: "0 0 10px 2px #003366",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                    color: "#2C2C2C",
                  }}
                >
                  dateRegistration: {JSON.stringify(dateRegistration)}
                  <TrainingSchoolRegistration
                  name_training_school={name_training_school}
                  year_training_school={year_training_school}
                  
                  />
                </div>
               */}
                {formattedToday <= dateRegistration ? (
                  <div
                    style={{
                      boxShadow: "0 0 10px 2px #003366",
                      margin: "20px",
                      padding: "10px",
                      borderRadius: "10px",
                      color: "#2C2C2C",
                    }}
                  >
                    <TrainingSchoolRegistration
                      name_training_school={name_training_school}
                      year_training_school={year_training_school}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      boxShadow: "0 0 5px 2px red",
                      margin: "20px",
                      padding: "10px",
                      borderRadius: "10px",
                      color: "white",
                      backgroundColor: "red",
                    }}
                  >
                    <h2>Il termine per l'iscrizione è scaduto.</h2>
                  </div>
                )}

              </div>
            </div>
          </TabPane>
          <TabPane tabId="info">
            {content.info &&
              visualizationMode(
                <div
                  style={{
                    padding: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: content.info,
                  }}
                />
              )}
          </TabPane>
        </TabContent>
      )}
    </div>
  );

  return (
    <div>
      <Toaster />
      <div className="row">
        <div>{contentTrainingSchool}</div>
      </div>
    </div>
  );
};

export default TrainingSchool;
